import { createSelector } from "reselect";

import { identity } from "~/tools/identity";

import type { RootState } from "../RootState";

import type { LayoutState, MainMenuState } from "./LayoutState";

const getLayoutState = (state: RootState): LayoutState => state.layout;

export const selectLayoutState: (state: RootState) => LayoutState = createSelector([getLayoutState], (st) =>
	identity(st),
);

const getMainMenu = (state: RootState): MainMenuState => state.layout.mainMenu;

export const selectMainMenuOpen: (state: RootState) => boolean = createSelector(
	getMainMenu,
	(mainMenu) => mainMenu.open,
);

export const selectWestActivePane = createSelector([selectLayoutState], ({ panes, activePanes }) =>
	activePanes.west == null ? undefined : panes.west.get(activePanes.west),
);
